const check_highlights = [
  'facility_free_shuttles',
  'facility_no_shuttles',
  'facility_shuttle_frequency',
  'facility_distance',
  'facility_free_cancellation',
  'facility_accessibility',
  'facility_eletric_car',
  'facility_additional_comments',
];

const check_highlights2 = [
  'dtc_type',
  'acessibility_shuttle',
  'acessibility_spaces',
  'cancellation',
  'facility_parking_type',
  'parking_condition',
  'parking_evcharge',
  'parking_evcharge_fee',
  'parking_location',
  'parking_oversize',
  'parking_oversize_fee',
  'parking_paved',
  'parking_stall_divider',
  'shuttle_availability',
  'shuttle_continuous',
  'shuttle_cost_included',
  'shuttle_end_time',
  'shuttle_frequency',
  'shuttle_schedule',
  'shuttle_start_time',
  'shuttle_type',
  'shuttle_vehicle',
  'shuttle_vehicle_capacity',
  'temporary_notice'
]

export const isShowHighlights = (highlights) => {
  return (
    highlights?.length > 0 &&
    highlights.find(
      (highlight) =>
        check_highlights.indexOf(highlight.type) !== -1 &&
        highlight.check !== false
    )
  );
};

export const isShowHighlights2 = (highlights2) => {
  const allowedKeys = new Set(check_highlights2);

  return (
    highlights2?.length > 0 &&
    highlights2.some((highlight) => {
      const key = `${highlight?.structfield_key || ''}`.trim().toLowerCase();
      const value = `${highlight?.structfield_value || ''}`.trim();
      const notes = `${highlight?.structfield_notes || ''}`.trim();
      return allowedKeys.has(key) && (value.length > 0 || notes.length > 0);
    })
  );
};

export const isShowAnyHighlights = (highlights, highlights2) => {
  return Boolean(isShowHighlights(highlights) || isShowHighlights2(highlights2));
};
